import axios from 'axios';
import { GET_TRANSACTIONS, LOADING, SAVE_SEARCH_PARAM, SAVE_PAGINATION_DATA } from '../types';

const BASE_URL = 'http://quicktellerrecurring-uat.k8.isw.la';
// const BASE_URL = '/qr-transaction-portal-url';
const email = 'support@interswitchgroup.com';

export const getTransactions = (payload) => dispatch => {
    dispatch(setLoading(true));
    axios.get(`${BASE_URL}/api/v1/qranalytics`, {
        params: {
            transactionReference: payload.transactionReference,
            status: payload.status,
            startDate: payload.startDate,
            endDate: payload.endDate,
            customerEmail: payload.customerEmail,
            pageNo: payload.pageNo,
            pageSize: payload.pageSize
        },
        headers: {
            'email': email,
            'Content-Type': 'application/json'
        }
    })
        .then(function (response) {
            let tableData = response.data.pageData.map((data, key) => {
                return {
                    key,
                    amount: data.amount || '--',
                    email: data.customerEmail || '--',
                    transactionType: data.webPayTransactionType || '--',
                    qtResponseCode: data.qtResponseCode || '--',
                    webpayResponseCode: data.webPayResponseCode || '--',
                    transactionRef: data.transactionRef || '--',
                    customerId: data.customerId || '--',
                    status: data.status || '--',
                    transactionResponse: data.webPayResponseDescription || '--',
                    date: data.dateOfPayment || '--'
                }
            });
            dispatch(saveTransactions(tableData));
            dispatch(saveSearchParam(payload));
            const paginationData = {
                pageCount: response.data.pageCount,
                pageSize: response.data.pageSize,
                pageNo: response.data.pageNo,
                dataSize: response.data.dataSize,
            }
            dispatch(savePaginationData(paginationData));
        })
        .catch(function (error) {
            dispatch(setLoading(false));
            console.log(error);
        });
}

export const saveTransactions = (payload) => dispatch => {
    dispatch({
        type: GET_TRANSACTIONS,
        payload
    });
}

export const saveSearchParam = (payload) => dispatch => {
    dispatch({
        type: SAVE_SEARCH_PARAM,
        payload
    });
}

export const savePaginationData = (payload) => dispatch => {
    dispatch({
        type: SAVE_PAGINATION_DATA,
        payload
    });
}

//Loading
export const setLoading = (payload) => {
    return {
        type: LOADING,
        payload
    }
}
